import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createBillable } from "@/modules/work/billables/details/create/api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;

  // Mirror top-level dates into the type-specific billing config (without removing them from top-level)
  const type = values.type;
  const start_date = values.start_date;
  const end_date = values.end_date;

  if (type === "fixed") {
    rest.fixed_billing_config = {
      ...(rest.fixed_billing_config || {}),
      ...(start_date ? { start_date } : {}),
      ...(end_date ? { end_date } : {}),
    };
  } else if (type === "hourly") {
    rest.hourly_billing_config = {
      ...(rest.hourly_billing_config || {}),
      ...(start_date ? { start_date } : {}),
      ...(end_date ? { end_date } : {}),
    };
  } else if (type === "dedicated") {
    rest.dedicated_billing_config = {
      ...(rest.dedicated_billing_config || {}),
      ...(start_date ? { start_date } : {}),
      ...(end_date ? { end_date } : {}),
    };
  }

  const { attributed_to, ...filteredRest } = rest;
  const payload = {
    ...Object.fromEntries(
      Object.entries(filteredRest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
    status: values.status || "contracted",
  };

  if ("attributed_to" in values) {
    payload.attributed_to = attributed_to?.id ?? null;
  }

  if (payload.milestones && Array.isArray(payload.milestones)) {
    payload.milestones = payload.milestones.map(m => {
      if (typeof m === 'object' && m !== null) {
        return m.id;
      }
      return m;
    });
  }

  return payload;
}

export function useCreateBillable() {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildPayload(values);
      const response = await createBillable({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Billable Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
}
